import React from 'react';
import { fetchConnector, FetchPNLAnalyticsPropsFromRedux } from '../dataFetcher';
import { SimpleTableColumnConfig, TableSize } from '../../tables/types';
import { exposuresNumFormatter } from '../../common/exposures';
import ExpandableTable, { ExpandableTableConfig } from '../../tables/ExpandableTable';
import { UniqueTableName } from '../../common/uniqueTableName';
import { AggFuncName } from '../../common/cellRangeAgg';
import { PNLAnalyticsEndpoint, PNLFetchStatus } from '../../actions/pnlAnalytics';
import { PNLGoodiesNonCompletedResponses } from '../PaperPlaceHolder';
import { BackOfficeMiscDataResp } from '../fetchTypes';
import { kFormatter, redOnlyHundred } from '../../containers/pivotHelper';
import { rawNumFormat } from '../common/CommonPNLSummaryTable';

type Props = FetchPNLAnalyticsPropsFromRedux & { withDeals?: boolean };

const pivotColumns: Array<SimpleTableColumnConfig> = [
    { name: 'account_code', title: 'Account' },
    {
        name: 'book',
        title: 'Book',
    },
    {
        name: 'strategy',
        title: 'Strategy',
        hoverElement: (row) => {
            return <div>{row['strategy']}</div>;
        },
    },
    {
        name: 'deal',
        title: 'Deal',
        hoverElement: (row) => {
            return <div>{row['deal']}</div>;
        },
    },
    {
        name: 'margin',
        title: 'Margin',
        bodyTemplate: kFormatter,
        textColor: redOnlyHundred,
        hoverElement: (row, val) => {
            let raw_val = row['margin'] as number;
            return <div>{rawNumFormat(raw_val)}</div>;
        },
    },
    {
        name: 'margin_pp',
        title: 'Margin PP',
        bodyTemplate: kFormatter,
        textColor: redOnlyHundred,
        hoverElement: (row, val) => {
            let raw_val = row['margin_pp'] as number;
            return <div>{rawNumFormat(raw_val)}</div>;
        },
    },
];

const MarginCall = (props: Props) => {
    const config: ExpandableTableConfig = {
        uniqueTableName: UniqueTableName.TommorowsMarginCall,
        title: 'Intraday Margin Call',
        size: TableSize.Small,
        columns: pivotColumns,
        grandTotal: true,
        aggFormatVal: (aggFuncName: AggFuncName, val: number) => {
            return aggFuncName === AggFuncName.Count ? val : exposuresNumFormatter(val);
        },
        pivotDepth: 3,
        defaultExpandable: 0,
        stickyHeader: true,
    };

    const BackOfficeMiscData = props.pnlAnalytics.back_office_misc;

    if (BackOfficeMiscData.status !== PNLFetchStatus.COMPLETED) {
        return (
            <PNLGoodiesNonCompletedResponses endpoint={PNLAnalyticsEndpoint.BackOfficeMisc} data={BackOfficeMiscData} minHeight={'462px'} />
        );
    }

    let respData = BackOfficeMiscData.data! as BackOfficeMiscDataResp;

    return <ExpandableTable data={respData.tommorows_margin_call} config={config} />;
};

export default fetchConnector(MarginCall);
